import styled, { css } from 'styled-components';
import { largeMediaQuery, mediumMediaQuery, smallMediaQuery } from '../../common/utilities/sizeHelpers';

export const LargeCardTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    height: 40px;
    padding: 8px 15px;
    font-size: 0;
    line-height: 1.29;
    background-color: white;
    border-bottom: 1px solid #eee;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
`;

const LargeForecastCardStyles = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const LargeForecastCardContainer = styled.li`
    ${LargeForecastCardStyles}
    width: 170px;
    height: 260px;
    margin-right: 4px;
    background: #f9f9f9;
    min-width: 170px;
    scroll-snap-align: start;
`;

export const LargeForecastCardWrap = styled.div`
    ${LargeForecastCardStyles}
    width: 100%;
    height: 220px;
`;

export const LargeCardHourDayStyle = css`
    font-size: 18px;
    font-weight: 400;
`;

interface ForecastCardTitleHourDayProps {
    textColor?: string;
    isDayTitleText?: boolean;
}
export const ForecastCardTitleHourDay = styled.span<ForecastCardTitleHourDayProps>`
    ${LargeCardHourDayStyle}
    color: ${({ textColor }) => textColor ? textColor : '#aaa'};
    ${({ isDayTitleText }) =>  isDayTitleText && `
        margin-left: 8px;
    `}
`;

export const PageContentContainerStyle = css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: auto;
    width: 100%;
    padding-left: 4%;
    padding-right: 4%;

    @media ${largeMediaQuery} {
        width: calc(1218px + 8%);
    }

    @media ${mediumMediaQuery} {
        padding-left: 15px;
        padding-right: 15px;
    }
`;

interface ForecastDataContainerProps {
    isMouseBtnDown: boolean;
    isDailyForecastView?: boolean;
}

export const ForecastDataContainer = styled.div<ForecastDataContainerProps>`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    overflow-x: scroll;
    align-items: flex-start;
    min-height: 285px;
    margin-top: -1px;
    ${({ isDailyForecastView }) => isDailyForecastView && `
        padding-bottom: 32px;
    `}
    height: auto;
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    ${({ isMouseBtnDown }) => isMouseBtnDown && `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        cursor: -moz-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    `}
    transition: all 0.2s;
    scrollbar-width: 12px;
    &::-webkit-scrollbar {
        height: 8px;
        width: 13px;
    }
    &::-webkit-scrollbar-button {
        display: block;
        height: 8px;
        width: 0;
    }
    &::-webkit-scrollbar-thumb {
        background: white;
        height: 8px;
        border-radius: 0;
    }
    &::-webkit-scrollbar-track-piece {
        background: rgba(255,255,255,0.2);
    }

    @media ${smallMediaQuery} {
        flex-direction: column;
        overflow-x: hidden;
        padding-bottom: 3px;
        scrollbar-width: none;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        &::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 0;
            height: 0;
        }
    }
`;